module.exports = __webpack_public_path__ + "static/img/weather60.3d284789.png";